import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import EditVehicleForm from '../../../modules/vehicles/components/EditVehicleForm';
import { useParams } from 'react-router-dom';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';

const EditVehicle = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { apiData } = useFormsIntegrationHelpers({
    queryKey: ['vehicles', id],
    id,
    singleGetApi: `/admin/vehicles/${id}`,
    editApi: `/admin/vehicles/${id}`,
    itemName: t('body_type'),
    listRoute: '/vehicles'
  });
  const dispatch = useDispatch();

  dispatch(
    setBreadCrumbsData({
      page_title: `${t('edit_vehicle')}${apiData?.chassis ? ` - ${apiData?.chassis}` : ''}`
    })
  );

  return (
    <div>
      <EditVehicleForm />
    </div>
  );
};

export default EditVehicle;
